import { TableCell, TableRow } from "@mui/material";
import styles from "../creditreport.module.css";
import { useState } from "react";
import MultiGoalCell from "./MultiGoalCell";
import GoalExpandPanel from "./GoalExpandPanel";

const TenantRow = ({ avatar, name, sub, scoreOld, scoreNew, pts, ptsType, tierLabel, tierCls, goals }) => {
    const [expanded, setExpanded] = useState(false);
    const isMulti = goals.length > 1;

    return (<>
        <TableRow className={isMulti && expanded ? styles.rowExpanded : ""}>
            {/* Resident */}
            <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                <div className={`${styles.AvatarSec}`}>
                    <div className={styles.ProfileImg}>
                        <img src={avatar} alt={name} />
                    </div>
                    <div className={styles.TenantSec}>
                        <span>{name}</span>
                        <p>{sub}</p>
                    </div>
                </div>
            </TableCell>

            {/* Score */}
            <TableCell className={styles.TableBodyText}>
                <div className={styles.scorePair}>
                    <span className={styles.scoreOld}>{scoreOld}</span>
                    <span className={styles.scoreArrow}>→</span>
                    <span className={styles.scoreNew}>{scoreNew}</span>
                </div>
            </TableCell>

            {/* Pts */}
            <TableCell className={styles.TableBodyText}>
                <span className={`${styles.ptsBadge} ${ptsType === "up" ? styles.ptsUp : styles.ptsFlat}`}>
                    {pts}
                </span>
            </TableCell>

            {/* Tier */}
            <TableCell className={styles.TableBodyText}>
                <span className={`${styles.tierChip} ${styles[tierCls]}`}>{tierLabel}</span>
            </TableCell>

            {/* Goal cell */}
            <TableCell className={styles.TableBodyText}>
                <MultiGoalCell
                    goals={goals}
                    expanded={expanded}
                    onToggle={() => setExpanded(p => !p)}
                />
            </TableCell>
        </TableRow>

        {/* Expanded panel row — only when multi-goal and open */}
        {isMulti && expanded && (<GoalExpandPanel goals={goals} colSpan={5} />)}
    </>);
}

export default TenantRow;